import React, { useEffect, useState } from "react";
import { Spinner, Button, Alert } from "react-bootstrap";
import {  useDispatch, useSelector } from "react-redux";
import BannerTutorial from "./components/banner";
import TutorialBanner from "../../../../assets/images/tutorial/tradesmens-banner-t.png";
import unlimitedContracts from "../../../../assets/images/tutorial/icon/contract-agreement.png";
import milestonesIcon from "../../../../assets/images/tutorial/icon/milestone.png";
import paymentsIcons from "../../../../assets/images/tutorial/icon/payment.png";
import downloadIcon from "../../../../assets/images/tutorial/icon/file.png";
import privacyIcon from "../../../../assets/images/tutorial/icon/compliant.png";
import marketIcon from "../../../../assets/images/tutorial/icon/content-strategy.png";
import subContractorsIcon from "../../../../assets/images/tutorial/icon/workers.png";
import eSign from "../../../../assets/images/tutorial/icon/sign.png";
import websiteIcon from "../../../../assets/images/tutorial/icon/application1.png";
import serverIcon from "../../../../assets/images/tutorial/icon/cloud-server.png";
import IntroContent from "./components/intro-content";
import Features from "./components/features";
import VideoSection from "./components/video-section";
import TermsCondition from "./components/terms-condition";
import {
  acceptContractTerms,
  getSubscribedUser,
  cancelSubscription,
} from "../../../../slices/thunk";
import Pricing from "./components/pricing";
import SubscriptionModal from "pages/stripe/subriptionModal";
import { TwoButtonAlert } from "Common/twoButtonAlert";
import { IoCheckmarkCircleOutline, IoTrashOutline } from "react-icons/io5";
import videoTut from '../../../../assets/images/tuVideo.mp4'
import { selectPaymentProvider, selectUserDetails } from "slices/userProfile/reducer";
import SubscriptionModalDeluxe from "components/deluxe/deluxDeluxSubcriptionModal";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import "./subscription-modern.css";
import api from "Common/api";
//test
interface ContractListProps {
  handleStatus: (values?: any) => void;
  setPaymentPageShow?:any
}

const Tutorial: React.FC<ContractListProps> = ({ handleStatus ,setPaymentPageShow}) => {
  const [alertDetails,setAlertDetails]= useState({
    status: false,
    title: "Warning!",
    message: "You’re about to delete your account forever,",
    icon: IoTrashOutline,
    button1Text: "Keep it",
    button2Text: "Delete",
    button1Style: "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
    button2Style: "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition",
    onButton1Click: () => console.log("Saved "),
    onButton2Click: () => console.log("Deleted "),
  })
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [subriptionModalStatus, setSubriptionModalStatus] = useState<boolean>(false);
  const [planDetails,setPlanDetails]= useState("")
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);
  const userSubscribed = useSelector((state: any) => state.UserProfile.subscribedData);
  const trialEligible = userSubscribed?.trialEligible === true;

  useEffect(() => {
    document.title = "Tradesmen Contract Builder";
  }, []);

  useEffect(() => {
    setLoading(true);
    dispatch(getSubscribedUser()).finally(() => {
      setLoading(false);
    });
  }, [dispatch]);

  const recordTermsAcceptance = () => {
    dispatch(acceptContractTerms(true));
  };

  const handleAlertClick = () => {
    setNotification(null);
  };
  const introContentHtml = trialEligible
    ? `<p><strong>The Tradesmen’s Collective</strong> gives contractors one secure workspace to create professional agreements, collaborate with homeowners, and keep every project moving.</p><p>Start with a <strong>30-day free trial</strong>. Explore every contract feature before your first subscription payment.</p>`
    : `<p><strong>The Tradesmen’s Collective</strong> gives contractors one secure workspace to create professional agreements, collaborate with homeowners, and keep every project moving.</p><p>Choose monthly or annual billing to restore access to Contract Builder.</p>`;

  const featuresData = [
    { icon: unlimitedContracts, feature: "Create Unlimited Contracts" },
    { icon: milestonesIcon, feature: "Add Milestones" },
    { icon: paymentsIcons, feature: "Set Up & Schedule Payments" },
    { icon: downloadIcon, feature: "Free Downloads and share" },
    { icon: subContractorsIcon, feature: "Add Sub-contractors" },
    { icon: websiteIcon, feature: "Get your dedicated Website" },
    { icon: privacyIcon, feature: "Maintain complete Privacy" },
    { icon: eSign, feature: "E-Docu Signing" },
    { icon: serverIcon, feature: "AWS based Servers for highend Security" },
    { icon: marketIcon, feature: "Market your business on Social Media" },
  ];
  const videoContent = `Explore the journey and see how it actually functions, so you can make the best out of it. Tutorials are always useful. Demonstrate the process by just simply watching this tutorial video.`;
  const paymentProvider = useSelector(selectPaymentProvider)

  const handleStripePc = (plan:any) => {
setPlanDetails(plan)
setSubriptionModalStatus(true)

  };
  const scheduleYearlySwitch = async (plan: any) => {
    setLoading(true);
    try {
      const isEmployee = user?.[0]?.is_test_stripe_user === 1;
      const response: any = await api.post("/stripe-sub/switch-to-yearly", {
        yearlyPriceId: isEmployee ? plan?.regular_priceIDTest : plan?.regular_priceID,
      });
      await dispatch(getSubscribedUser());
      setNotification({
        status: true,
        message: response?.message || "Your yearly plan will start at the next renewal.",
        variant: "success",
      });
    } catch (requestError: any) {
      setNotification({
        status: true,
        message: requestError?.response?.data?.message || requestError?.message || "The yearly switch could not be scheduled.",
        variant: "warning",
      });
    } finally {
      setLoading(false);
    }
  };
  const confirmYearlySwitch = (plan: any) => {
    setAlertDetails({
      status: true,
      title: "Switch to yearly billing?",
      message: "Your monthly plan stays active. Yearly billing starts automatically at the next renewal, with no charge today.",
      icon: IoCheckmarkCircleOutline,
      button1Text: "Keep monthly",
      button2Text: "Schedule switch",
      button1Style: "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
      button2Style: "px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition",
      onButton1Click: () => {},
      onButton2Click: () => { void scheduleYearlySwitch(plan); },
    });
  };
  const handleCancelSubscription = () => {
    setLoading(true);
    dispatch(cancelSubscription()).then((resp: any) => {
      dispatch(getSubscribedUser());
      setNotification({
        status: true,
        message: resp.message,
        variant: "success",
      });
      setLoading(false);
    });
  };
const user:any = useSelector(selectUserDetails)

if(!user){
  return <div></div>
}
  return (
    <div className="subscription-page">

      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {notification.message}
          </Alert>
        </div>
      )}
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "200px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div className="subscription-page__content">
        {setPaymentPageShow && <Button
          variant="link"
          className="subscription-back-button"
          onClick={() => setPaymentPageShow(false)}
        >
          <ArrowLeft size={18} /> Back to contracts
        </Button>}
   
          <BannerTutorial
            banner={TutorialBanner}
            title={"Welcome to the"}
            subTitle={"Tradesmen’s Collective"}
            titleColor={"#2B2B2B"}
            subTitleColor={"#1C4ED7"}
            trialEligible={trialEligible}
          />
          <IntroContent content={introContentHtml} />
          <Pricing
            handleCancel={handleCancelSubscription}
            handleStartTrial={handleStripePc}
            handleSwitchToYearly={confirmYearlySwitch}
            trialEligible={trialEligible}
          />
          <div className="subscription-trust-strip">
            <ShieldCheck size={22} />
            <span>Secure payments · Cancel anytime · Your project data stays protected</span>
          </div>
          <TermsCondition trialEligible={trialEligible} />
          <Features featureTitle={"Features"} featuresList={featuresData} />
          <VideoSection
            title="See how it works"
            videoTitle="Build your first contract with confidence"
            videoContent={videoContent}
            videoSrc={videoTut}
          />
        </div>
      )}
       {/*  */}
{paymentProvider ==="stripe" ?<SubscriptionModal trialEligible={trialEligible} afterSubmit={()=>{
           recordTermsAcceptance()
           setSubriptionModalStatus(false)
           setAlertDetails({
            status: true,
            title: "🎉 Subscription Completed!",
            message: "You can now create contracts. Check out our guide to get started!",
            icon: IoCheckmarkCircleOutline, // ✅ Success-style icon (you can import this from react-icons)
            button1Text: "See Guide",
            button2Text: "Start Now",
            button1Style: "px-4 py-2 rounded-lg bg-blue text-black hover:bg-blue-600 transition",
            button2Style: "px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition",
            onButton1Click: () => handleStatus(),
            onButton2Click: () => handleStatus(),
           })
       }} plan={planDetails} isOpen={subriptionModalStatus} onClose={() => {
        setSubriptionModalStatus(false)
       }} />: <SubscriptionModalDeluxe trialEligible={trialEligible} afterSubmit={()=>{
           recordTermsAcceptance()
           setSubriptionModalStatus(false)
          

           setAlertDetails({
            status: true,
            title: "🎉 Subscription Completed!",
            message: "You can now create contracts. Check out our guide to get started!",
            icon: IoCheckmarkCircleOutline, // ✅ Success-style icon (you can import this from react-icons)
            button1Text: "See Guide",
            button2Text: "Start Now",
            button1Style: "px-4 py-2 rounded-lg bg-blue text-black hover:bg-blue-600 transition",
            button2Style: "px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition",
            onButton1Click: () => handleStatus(),
            onButton2Click: () => handleStatus(),
           })
       }} plan={planDetails} isOpen={subriptionModalStatus} onClose={() => {
        setSubriptionModalStatus(false)
       }}/>  }
    
      <TwoButtonAlert setDetails={setAlertDetails}  details={alertDetails}/>

    </div>
  );
};

export default Tutorial;
